import {NgModule} from "@angular/core";
import {FeedbackComponent} from "./feedback.component";
import {FeedbackModalComponent} from "./feedback-modal.component";
import {ModalModule} from "@herbis/ngx-modal";
import {FeedbackScreenshotComponent} from "./feedback-screenshot.component";
import {FeedbackService} from "./feedback.service";
import {CommonModule} from "@angular/common";



export class FeedbackModule {
  constructor() {}
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    FeedbackComponent,
    FeedbackModalComponent,
    FeedbackScreenshotComponent
  ],
  imports: [
    CommonModule,
    ModalModule
  ],
  exports: [
    FeedbackComponent,
    FeedbackScreenshotComponent
  ],
  providers: [
    FeedbackService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
